import { DropTarget as reactDropTarget } from 'react-dnd';
import React from 'react';
import PropTypes from 'prop-types';

import DnDItemTypes from '../DynamicDnD/DnDItemTypes';

const dropTarget = {
  canDrop: props =>
    props.definition &&
    (props.definition.scope === 4 || props.definition.scope === 5),

  drop(props, monitor) {
    props.handleTreeDrop(
      monitor.getItem().selectedEntries.map(entry => ({
        id: 0,
        name: entry.title,
        expression: entry.keyword,
      })),
      props.definition,
    );
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

const DefinitionTreeNode = ({ connectDropTarget, isOver, canDrop, definition, handleClick }) => {
  let iconType = 'folder-green';
  switch (definition.scope) {
    case 1:
      iconType = 'folder-light-green';
      break;
    case 2:
      iconType = 'folder-purple';
      break;
    case 3:
      iconType = 'folder-light-purple';
      break;
    case 4:
      iconType = 'folder-yellow';
      break;
    case 5:
      iconType = 'folder-light-yellow';
      break;
    default:
      iconType = 'folder-green';
  }

  return connectDropTarget(
    <button
      className={`definitions ${canDrop && isOver ? 'droppable' : ''}`}
      data-tooltip
      aria-haspopup="true"
      title={definition.folderName}
      key={definition.definitionId}
      onClick={() => handleClick(definition)}
    >
      <span className={`node-icon fa fa-folder ${iconType}`} />{' '}
      <span className="define-color">{definition.folderName}</span>
    </button>,
  );
};

DefinitionTreeNode.propTypes = {
  connectDropTarget: PropTypes.func,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  definition: PropTypes.shape({}),
  handleClick: PropTypes.func,
};

export default reactDropTarget([DnDItemTypes.DnD_ITEM_TYPE_3], dropTarget, collect)(
  DefinitionTreeNode,
);
